import type { I18N } from '@vista-digital/i18n'
import { gtm } from '../../gtm.service'
import { Ecommerce, EcommerceDataLayer } from '../../models-gtm'
import type { OrderTicketLineWithQuantity } from '../../utils/getTicketItems'
import { getTicketItem } from '../../utils/getTicketItems'
import { mapFilmData } from '../../utils/mapFilmData'
import { mapShowTimeData } from '../../utils/mapShowtimeData'
import type { CartDataGtm } from '../../utils/useCartData'

export class TicketsGtmEvents {
    public static addToCart(ticketLine: OrderTicketLineWithQuantity, cartData: CartDataGtm, i18n: I18N) {
        const item = this.getTicketEcommerceModel(ticketLine, cartData, i18n)
        if (!item) return
        gtm.sendDataLayer(new EcommerceDataLayer('add_to_cart', item))
    }

    public static removeFromCart(ticketLine: OrderTicketLineWithQuantity, cartData: CartDataGtm, i18n: I18N) {
        const item = this.getTicketEcommerceModel(ticketLine, cartData, i18n)
        if (!item) return
        gtm.sendDataLayer(new EcommerceDataLayer('remove_from_cart', item))
    }

    // Private methods

    private static getTicketEcommerceModel(
        ticketLine: OrderTicketLineWithQuantity,
        cartData: CartDataGtm,
        i18n: I18N
    ): Ecommerce | null {
        if (!cartData.film || !cartData.showtime || !cartData.site) return null
        const filmData = mapFilmData(cartData.film, i18n)
        const showtimeData = mapShowTimeData(cartData.showtime, cartData.site, i18n)
        const item = getTicketItem(filmData, showtimeData, ticketLine)

        return new Ecommerce([item])
    }
}
export type TicketsGtmEventsKeys = Exclude<keyof typeof TicketsGtmEvents, 'prototype'>
